import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';

import {
    IconButton,
} from '@material-ui/core';

import * as ProgramStore from '../../app/store/ProgramStore';
import {
    FavouritesIcon, FavouritesUncheckedIcon,
} from '../icons';

const styles = theme => ({
    icon: {
        fontSize: 'inherit',
    },
    iconChecked: {
        fontSize: 'inherit',
        color: theme.palette.primary.main,
    },
});

class Favourite extends React.Component {
    toggleFavourite = (taskId, patientProgramElementId, isFav) => () => {
        const data = {
            taskId,
            patientProgramElementId,
            patientProgramId: this.props.programDetails.id,
            on: !isFav,
        };

        this.props.toggleFavourite(data, { reducerParams: { patientProgramId: data.patientProgramId } });
    }

    render() {
        const {
            classes, className, taskId, patientProgramElementId, programDetails, clientConfig, translate,
        } = this.props;

        if (!clientConfig.appSetup.features.favourites || !taskId || !programDetails) {
            return null;
        }

        const isFav = programDetails.favourites[taskId];

        return (
            <IconButton
                className={className}
                onClick={this.toggleFavourite(taskId, patientProgramElementId, isFav)}
                title={isFav ? translate('favourites.removeFavourite') : translate('favourites.setFavourite')}
            >
                {isFav ? (<FavouritesIcon className={classes.iconChecked} />) : (<FavouritesUncheckedIcon className={classes.icon} />)}
            </IconButton>
        );
    }
}

Favourite.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    toggleFavourite: PropTypes.func.isRequired,
    clientConfig: PropTypes.object.isRequired,
    className: PropTypes.string,
    programDetails: PropTypes.object,
    taskId: PropTypes.string,
    patientProgramElementId: PropTypes.string,
};

Favourite.defaultProps = {
    className: null,
    programDetails: null,
    taskId: null,
    patientProgramElementId: null,
};


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    programDetails: state.programStore.currentProgram,
    clientConfig: state.auth.clientConfig,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(ProgramStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Favourite));
